// @flow
type OnlyRenderChildrenProps = {
  children: any,
}

const OnlyRenderChildren = (props: OnlyRenderChildrenProps) => {
  return props.children
}

export default OnlyRenderChildren
